import HORIZONTAL_PLP_CONSTANTS from './HorizontalCategory.constants';

export const setHorizontalPlpLoading = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.SET_HORIZONTAL_PLP_LOADING,
  };
};

export const getHorizontalCategoryProducts = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.FETCH_HORIZONTAL_CATEGORY_PRODUCTS,
  };
};

export const getMoreHorizontalCategory = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.FETCH_MORE_HORIZONTAL_CATEGORY_PRODUCTS,
  };
};

export const setHorizontalCategoryProducts = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.SET_HORIZONTAL_CATEGORY_PRODUCTS,
  };
};

export const resetHlpProducts = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.RESET_HORIZONTAL_CATEGORY_PRODUCTS,
  };
};

export const setHlpCatsFetched = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.SET_HLP_SUBCATEGORIES_FETCHED,
  };
};

export const setHlpCID = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.SET_HLP_CID,
  };
};

export const setHorizontalPageSEOData = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.SET_HORIZONTAL_SEO_DATA,
  };
};
export const clearHorizontalPageSEOData = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.CLEAR_HORIZONTAL_SEO_DATA,
  };
};

export const setHplpAppliedSortId = (payload) => ({
  type: HORIZONTAL_PLP_CONSTANTS.SET_HPLP_APPLIED_SORT_ID,
  payload,
});

export const setHplpFilters = (payload) => ({
  type: HORIZONTAL_PLP_CONSTANTS.SET_HPLP_FILTERS,
  payload,
});

export const setHplpAppliedFilters = (payload) => ({
  type: HORIZONTAL_PLP_CONSTANTS.SET_HPLP_APPLIED_FILTERS,
  payload,
});

export const setIsHplp = (payload) => ({
  type: HORIZONTAL_PLP_CONSTANTS.SET_IS_HPLP,
  payload,
});

export const getHorizontalCategoryProductsApp = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.FETCH_HORIZONTAL_CATEGORY_PRODUCTS_APP,
  };
};

export const setHplpInitialDataLoading = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.SET_HPLP_INITIAL_DATA_LOADING,
  };
};

export const getInitialHplpData = (payload) => {
  return {
    payload,
    type: HORIZONTAL_PLP_CONSTANTS.FETCH_INITIAL_HPLP_DATA,
  };
};
